"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TenantId = exports.Stage = void 0;
var Stage;
(function (Stage) {
    Stage["DEV"] = "dev";
    Stage["ESSP"] = "essp";
    Stage["BETA"] = "beta";
    Stage["GAMMA"] = "gamma";
    Stage["PROD"] = "prod";
})(Stage = exports.Stage || (exports.Stage = {}));
exports.TenantId = 'shift-app';
